import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import './Theme.css';

const Home = () => {
  return (
    <main className="home">

      {/* Self Portrait / Hero Section */}
      <div className="portrait-section">
        <img
          src="/images/self-portrait.png"
          alt="Self Portrait"
          className="self-portrait"
        />
        <h1>Data Engineer building reliable pipelines, data models, and analytics systems.</h1>
        <p className="hero-subtitle">
          I turn fragmented operational and business data into trusted, decision-ready
          datasets using SQL, Python, APIs, Snowflake, and BI tools.
        </p>
        <div className="hero-links">
          <Link to="/resume" className="hero-link">Resume</Link>
          <a
            href="https://www.linkedin.com/in/garrett-albracht"
            target="_blank"
            rel="noopener noreferrer"
            className="hero-link"
          >
            LinkedIn
          </a>
        </div>
      </div>

      {/* About Me Section */}
      <section className="about-section">
        <h2>About Me</h2>
        <p>
          Hi, I'm Garrett Albracht, a Data Engineer with a B.S. in Software Engineering from
          Washington State University (April 2024). I build the pipelines, data models, and
          analytics systems that teams rely on to make decisions with confidence.
        </p>

        <p>
          My work spans SQL, Python, Snowflake, and dbt for transformation and modeling; the
          Amazon SP-API and Microsoft Fabric for ingestion and storage; and Power BI for
          reporting. I turn operational, ecommerce, and inventory data into reporting people
          can actually trust. Dive into the projects below to see how I work.
        </p>
      </section>

      {/* Featured Projects Section */}
      <section className="projects-section">
        <h2>Featured Projects</h2>
        <div className="project-links">
          {/* Flagship: Warehouse Consolidation Opportunity Model */}
          <Link to="/material-zone-analytics" className="project-link">
            <div className="project project--flagship">
              <h3>Warehouse Consolidation Opportunity Model</h3>
              <p>
                Scoring logic and storage-zone constraints applied to warehouse system data to
                surface consolidation recommendations, identifying ~5,692 opportunities.
              </p>
            </div>
          </Link>

          {/* Amazon SP-API Data Pipeline & Category Analytics */}
          <Link to="/amz-category-analysis" className="project-link">
            <div className="project">
              <h3>Amazon SP-API Data Pipeline &amp; Category Analytics</h3>
              <p>
                A small data product built from a messy external API: extraction, cleaning and
                normalization, curated datasets, and category-level insights.
              </p>
            </div>
          </Link>

          {/* Amazon Commerce Reporting Model & Power BI Dashboard */}
          <Link to="/sales-dashboard" className="project-link">
            <div className="project">
              <h3>Amazon Commerce Reporting Model &amp; Power BI Dashboard</h3>
              <p>
                SP-API ingestion, SQL/Fabric storage and transformations, a curated reporting
                model, and a Power BI semantic model for the business.
              </p>
            </div>
          </Link>
        </div>
        <Link to="/projects" className="view-all-link">View all projects &rarr;</Link>
      </section>

      <section className="certifications-section">
        <h2>Credentials</h2>
        <div className="certification-groups">
          <div className="certification-group">
            <h3>In Progress</h3>
            <ul>
              <li>Microsoft PL-300: Power BI Data Analyst</li>
            </ul>
          </div>
          <div className="certification-group">
            <h3>Done</h3>
            <ul className="certification-list">
              <li className="certification-item">
                <div className="certification-item__header">
                  <a
                    href="https://www.credly.com/badges/cda3b7d0-3694-46fa-9553-027b40f2cbfb/public_url"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="certification-name certification-name--link"
                  >
                    AWS Skill Builder: Business Intelligence Badge
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="contact-section">
        <h2>Get in Touch</h2>
        <p>Let's talk data pipelines, analytics, and reporting.</p>
        <div className="contact-links">
          <a href="mailto:gjalbracht@gmail.com" className="contact-link">
            gjalbracht@gmail.com
          </a>
          <a
            href="https://www.linkedin.com/in/garrett-albracht"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-link"
          >
            Connect on LinkedIn
          </a>
        </div>
      </section>
    </main>
  );
};

export default Home;
